import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Preparation time was my biggest stress. With this 6-in-1 system, I reclaimed my weekends. The sequences flow beautifully and my students love the variety.',
  author: 'Grace M.',
  role: 'Yoga Instructor',
  location: 'London, UK'
}, {
  text: "The Cueing Scriptbook and the Class Themes Vault saved my life. The pack is worth 10 times its price — it's a total game-changer for my studio.",
  author: 'Sarah L.',
  role: 'Studio Owner',
  location: 'New York, USA'
}, {
  text: "As a newly certified instructor, I felt completely overwhelmed planning my first classes. YOGA READY™ gave me the exact framework I needed. I walk into the studio with so much confidence now, and my students think I've been teaching for years!",
  author: 'Emily R.',
  role: '200hr RYT',
  location: 'Austin, TX'
}, {
  text: "After 12 years of teaching, I was hitting major creative burnout. This system breathed new life into my sequences. The Class Themes Vault alone is brilliant. It's like having a master teacher planning alongside you.",
  author: 'Jessica T.',
  role: 'Senior Yoga Teacher',
  location: 'Denver, CO'
}, {
  text: "Running online vinyasa classes means I need my cues to be perfectly clear since I can't physically adjust students. The Cueing Scriptbook is incredibly precise. My retention rate for virtual classes has never been higher.",
  author: 'David M.',
  role: 'Vinyasa Instructor',
  location: 'Portland, OR'
}];
export function Testimonials() {
  return <section className="py-8 px-4 bg-white border-y-4 border-brand-rose/20" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <div className="text-center mb-6" data-id="element-165">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-166">
            WHAT YOUR COLLEAGUES ARE SAYING
          </h2>
          <p className="text-base font-bold text-brand-rose uppercase tracking-wide" data-id="element-167">
            Testimonials from professionals
          </p>
        </div>

        <div className="space-y-3" data-id="element-168">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream border-2 border-brand-rose/30 p-4 rounded-lg shadow-sm" data-id="element-169">
              <div className="flex gap-1 mb-2" data-id="element-170">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-171" />)}
              </div>
              <p className="text-brand-graphite/90 font-medium mb-3 leading-snug italic text-sm sm:text-base" data-id="element-172">
                "{t.text}"
              </p>
              <div className="border-t border-brand-rose/20 pt-3 flex items-center gap-3" data-id="element-173">
                <div className="w-10 h-10 rounded-full bg-brand-rose/20 flex items-center justify-center text-brand-rose font-extrabold text-lg border border-brand-rose/30" data-id="element-174">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-175">
                  <p className="font-bold text-brand-graphite text-sm" data-id="element-176">
                    {t.author}
                  </p>
                  <p className="text-[11px] sm:text-xs text-brand-graphite/70 font-bold uppercase tracking-wide" data-id="element-177">
                    {t.role} — {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}